/* Copyright (c) 2020 IceRock MAG Inc. Use of this source code is governed by the Apache 2.0 license. */
import React, { Fragment } from 'react';
var FeatureReadFooter = function () { return React.createElement(Fragment, null); };
export { FeatureReadFooter };
